define([
    'text!product-detail/component/more-products.html',
    'common/utils',
    'product-detail/store',

    'css!product-detail/component/more-products.css'
], function(
    tpl,
    Utils,
    Store
){
    return {
        template: tpl,
        data: function(){
            return {
                products: []
            };
        },
        methods: {
            init: function(){
                this.products = Store.getBestBuy();
            },
            genProductDetailLink: Utils.genProductDetailLink,
            getSkuMainImage: Utils.getSkuMainImage,
            getSkuBgColor: Utils.getSkuBgColor
        },
        created: function(){
            this.init();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail2024/component/more-products.js
// module id = 213
// module chunks = 0